import { ClaimAction } from "./types";

export const upsertClaim = (step_num, payload) =>
  ({
    type: ClaimAction.UPSERT_CLAIM,
    step_num,
    payload,
  } as const);

export const fetchClaimInfo = (payload) =>
  ({
    type: ClaimAction.FETCH_CLAIM_INFO,
    payload,
  } as const);

export const updateClaimState = (payload) =>
  ({
    type: ClaimAction.UPDTAE_CLAIM_STATE,
    payload,
  } as const);

export const uploadClaimImage = (payload) =>
  ({
    type: ClaimAction.UPLOAD_CLAIM_IMAGE,
    payload,
  } as const);

export const removeClaimImage = (payload) =>
  ({
    type: ClaimAction.REMOVE_CLAIM_IMAGE,
    payload,
  } as const);

export const cleanUpClaim = () =>
  ({
    type: ClaimAction.CLEAN_UP,
  } as const);

export const submitClaim = () =>
  ({
    type: ClaimAction.SUBMIT_CLAIM,
  } as const);
